/* eslint-disable no-nested-ternary */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/sharp-solid-svg-icons';
import { useCallback, useMemo } from 'react';
import { twMerge } from 'tailwind-merge';

import Button, { ButtonSize, ButtonVariant } from '@/components/button';
import Mark from '@/components/icons/Mark';
import Typography from '@/components/typography';
import { GLOBAL_TOOLTIP } from '@/constants/constants';
import { useFooterButtonFunctions } from '@/features/selectionsPanel/hooks/useFooterButtonFunctions';
import { useGenericSelectionPanelFunctions } from '@/features/selectionsPanel/hooks/useGenericSelectionPanelFunctions';
import { useFileManagementContext } from '@/providers/FileManagementProvider';

export const Footer = () => {
  const { onSaveSelectionsClick, getSaveButtonTooltip } =
    useFooterButtonFunctions();
  const { deselectAll } = useGenericSelectionPanelFunctions();
  const { activeFile, lastUpdatedTimestamp, saving, clearActiveFileWithToast } =
    useFileManagementContext();

  const handleOnDeselectAll = useCallback(
    (e) => {
      clearActiveFileWithToast();
      deselectAll(e);
    },
    [deselectAll, clearActiveFileWithToast]
  );

  const autoSaveText = useMemo(() => {
    return `Last Saved ${lastUpdatedTimestamp}`;
  }, [lastUpdatedTimestamp]);

  return (
    <div className="sticky bottom-0 flex w-full space-x-2 border-t-1 border-gray-10 bg-white p-2">
      <div className="flex w-full gap-2" id="save-button">
        {!activeFile ? (
          <>
            <div className="w-full flex-1">
              <Button
                className="h-[40px] w-full p-0"
                variant={ButtonVariant.SECONDARY}
                onClick={handleOnDeselectAll}
              >
                <Typography className="font-medium" variant="body1">
                  Clear
                </Typography>
              </Button>
            </div>
            <div className="w-full flex-1">
              <Button
                className="h-[40px] w-full flex-1 px-4 py-2"
                data-tooltip-content={getSaveButtonTooltip()}
                data-tooltip-id={GLOBAL_TOOLTIP}
                variant={ButtonVariant.PRIMARY}
                onClick={onSaveSelectionsClick}
              >
                <Typography className="font-medium" variant="body1">
                  Save
                </Typography>
              </Button>
            </div>
          </>
        ) : (
          <div className="flex w-full flex-col justify-center gap-2 border-gray-20">
            <div className="flex items-center justify-center gap-3">
              <FontAwesomeIcon
                className={twMerge('text-gray-60')}
                icon={faArrowsRotate}
                size="sm"
                spin={saving}
                style={{
                  animationDuration: '1s',
                }}
              />
              <Typography variant="body2">{autoSaveText}</Typography>
            </div>

            <Button
              className="gap-3"
              size={ButtonSize.SMALL}
              variant={ButtonVariant.TERTIARY}
              onClick={handleOnDeselectAll}
            >
              <span>
                <Mark className="h-3.5 w-3.5" />
              </span>
              Close
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
